import { computed, unref, type MaybeRef } from 'vue'
import { usePartnerNames } from '@/components/homePage/queries/conversionFunnel'

/**
 * Resolves a connectivity provider's display name from its numeric partner
 * ID via the `getAdvertiserDetails` GraphQL query (see
 * `usePartnerNames`/`conversionFunnel.js`). Falls back to the stringified
 * partner ID while the name hasn't loaded yet (or if it's unavailable).
 */
export function useConnectivityProviderName(partnerId: MaybeRef<number | null | undefined>) {
  // usePartnerNames accepts a reactive ref to an array of ids; only query
  // when we actually have a partnerId.
  const partnerIdList = computed(() => {
    const id = unref(partnerId)
    return id != null ? [id] : []
  })

  const { partners } = usePartnerNames(partnerIdList) as {
    partners: { value: { originalName?: { value?: string } }[] }
  }

  // conversionFunnel.js returns advertiserDetails: { nsid: { id }, originalName: { value } }
  const providerName = computed(() => partners.value?.[0]?.originalName?.value ?? String(unref(partnerId) ?? ''))

  return { providerName }
}
